import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ClockCounterClockwise } from "@phosphor-icons/react";

// B6 — non-drillable Handled History for RID / CTOP / CAP. Renders EXACTLY the five locked
// product fields with NO navigation/drill-down, NO PII, NO documents/payments/metadata.
export const HandledHistoryPanel = ({ testidPrefix = "handled-history" }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get("/shipments/handled-history")
      .then((r) => { if (alive) setRows(r.data?.rows || []); })
      .catch((e) => { if (alive) setError(e.displayMessage || "Could not load your Handled History."); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  return (
    <div className="grid-card grid-card-strong" data-testid={testidPrefix}>
      <div className="flex items-center gap-2 p-4 border-b border-[hsl(var(--border))]">
        <ClockCounterClockwise size={18} weight="duotone" />
        <span className="overline">HANDLED HISTORY</span>
      </div>
      {loading ? (
        <div className="p-8 mono text-sm" data-testid={`${testidPrefix}-loading`}>Loading…</div>
      ) : error ? (
        <div className="p-8 text-sm text-[hsl(var(--error))]" data-testid={`${testidPrefix}-error`}>{error}</div>
      ) : rows.length === 0 ? (
        <div className="p-10 text-center" data-testid={`${testidPrefix}-empty`}>
          <div className="overline mb-1">NOTHING YET</div>
          <p className="text-sm text-[hsl(var(--muted))]">
            Shipments you have handled will appear here once they are completed.
          </p>
        </div>
      ) : (
        <table className="table-air12">
          <thead>
            <tr>
              <th>Shipment Code</th>
              <th>Route</th>
              <th>Handled Date</th>
              <th>Handled Time</th>
              <th>Final Outcome</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={`${r.shipment_code}-${i}`} data-testid={`${testidPrefix}-row-${r.shipment_code}`}>
                <td><span className="id-chip">{r.shipment_code}</span></td>
                <td><span className="id-chip">{r.route}</span></td>
                <td className="mono text-sm">{r.handled_date}</td>
                <td className="mono text-sm">{r.handled_time}</td>
                <td className="text-sm font-semibold">{r.final_outcome}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
